// Styled
import styled from 'styled-components'
import { Logo } from '../logo'


const HeaderWrapper = styled.header`
    padding-top: ${ props => props.theme.spacing.extraLarge };
    display: flex;
    justify-content: center;
    z-index: 1;
    width: 100%;
}
`

type Props = {
    className?: string,
    style?: React.CSSProperties | undefined,
    isPlayerContext?: boolean,
}

export const Header = ({ className, style, isPlayerContext }: Props) => {

    return (
        <HeaderWrapper className = { className } style = { style }>
            <Logo 
                style={isPlayerContext ? { 
                    width: '90%', 
                    maxWidth: '400px',
                    height: 'auto' 
                } : undefined}
            />
        </HeaderWrapper>
    )
}